import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js'
import download from 'downloadjs'
import Pagination from './../../shared/pagination'
import SimpleEncrypt from 'simple-encryptor'
import csvHelper from '../importjsontocsv';
import orderdetailsaccordian from './../../orderdetailsAccordian'
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import {BasicSelect} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'orderlist',
	components: {
		orderdetailsaccordian,
		Paginate,
		Pagination,
		JsonExcel,
		DatePicker,
		Loader,
		BasicSelect
	},
	data() {
		return {
			//for order modification varibales
			// totalRows:0,
			listMerchantData: [],
			merchantnameFlt: '',
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			ponoFlt: '',
			shipidflt: '',
			searchchannel: '',
			searchstatus: '',
			fromDateFlt: '',
			toDateFlt: '',
			fromDateFltStatus: '',
			toDateFltStatus: '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			modifyOrderInput: {},
			isWholeOrderCancel: false,
			modalTitle: '',
			modalHeader: '',
			comfirmModal: false,
			modifyOrdere: false,
			isqtycheck: false,
			errmessage: '',
			modifyOrderID: '',
			//
			modifyprodList: [],
			orderProdList: [],
			// getNewWarehouseData:'',
			listOrdersData: [],
			listOrdersDataCsv: [],
			modalShow: false,
			modalMessageShow: false,
			pono: "",
			ponoFlt: "",
			shipidflt: "",
			fromDateFlt: "",
			toDateFlt: "",
			modelMessage: "",
			// totalPage: 0,
			// pageNo: 0,
			clientdata: [],
			resultCount: 0,
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			ClientErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			orderCancelShow: false,
			cancelOrderId: '',
			loginuserid: '',
			orderstatuslist: [{
				'status': 'created'
			}, {
				'status': 'allocated'
			}, {
				'status': 'picked'
			}, {
				'status': 'packed'
			}, {
				'status': 'dispatched'
			}, {
				'status': 'cancelled'
			}, {
				'status': 'rto'
			},
			{
				'status': 'sr'
			},
			{
				'status': 'Rejected'
			}
		],
			searchchannel: '',
			searchstatus: '',
			channellist: [],
			isLoading: false,
			displayCancel: false,
			// pageLimit: 10,
			formattedDate: '',
			shipmentdetails: false,
			shipmentdetailslist: '',
			orderidshipment: '',
			fromDateFltStatus: '',
			toDateFltStatus: '',
			statusFlag: false,
			labelfromdate: '',
			labeltodate: '',
			userid: '',
			showlist:true,
			cancelOrderFlag: false,
			modifyOrderFlag: false,
			cancelreasonid: '',
			listCancelReasonData: [],
			OthersReason: '',
			cancelReason: '',
			recordLimit: 0,
			limitExeed: false,
			item:{},
		   merchant:'',
		   listMerchantData1:[],
		   listMerchantData:[],
		   merchantList:[],
		   merchantname:'',
		   filterData:{},
		   selectedRow: {},
		   searchSLA :'',
		   slaclient:[],
			slaflag:false,
			rejectdetailslist: '',
			rejectdetails:false,
			orderid:'',
			rtvType:''
		}
	},

	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		this.calldateFunction();
		this.listClientData = '';
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		var innerpermissionEncrypt = window.localStorage.getItem('innerpermissiondata')
		var innerbytes = CryptoJS.AES.decrypt(innerpermissionEncrypt.toString(), 'Key');
		var innerplaintext = innerbytes.toString(CryptoJS.enc.Utf8);
		var innerdetail = JSON.parse(innerplaintext);
		this.getComponentPermission(innerdetail);
		this.reportname = this.$t('common.order')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
		this.encryptor = SimpleEncrypt(this.key);

		this.userid = userdetail.userid;
		var roleids = userdetail.roleid.split(',');
		for (var i = 0; i < roleids.length; i++) {
			if (roleids[i] == 40) {
				this.purchasingManager = parseInt(userdetail.roleid);
				this.isTrue = true;
			}
		}
		this.loginuserid = userdetail.userid;
		this.loginuseremail = userdetail.email;
		this.pageNo = 0;

		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')

		// User access conditions
		//if (userdetail.roleid == 1 || userdetail.roleid == 4) {
		if (userdetail.roleid) {
			this.displayCancel = true
		}
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantList();
		this.getSalesChannels();
		}
		this.user_type = userdetail.utype;
		var slaconfig = window.localStorage.getItem('slaconfig');
		this.slaclient = JSON.parse(slaconfig);

		this.slaflag = this.slaclient.some(item => {
			if (item.clientid == this.clientid) {
			  return true;
			} else {
			  this.slaflag = false;
			  return false;
			}
		  });

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				// this.getClientList();
				// this.getWarehouseList();
				this.getCancelReasonList();

				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.getMerchantList()
				this.showSelectWarehouse = true;
				this.getCancelReasonList();

				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				// this.getClientList();
				this.getCancelReasonList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
	}, // End computed
	methods: {

	   showorderDetailsForm(data){
		   console.log("test------>")
				this.selectedRow = data
				console.log(this.selectedRow,"------selected--------")
				this.showlist = false;
		},
		showRejectInfo(poid){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.shipmentdetailslist = '';
			this.orderid = poid
			this.input = {
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
				orderno: poid
			};
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'rejectDetailsOfOrder',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.rejectdetailslist = result.data.data;
						this.rejectdetails = true;
					} else {
						this.rejectdetailslist = {};
						this.rejectdetails = true;
					}
				}, error => {
					console.error(error)
				})
		},
		rejectdetailsClose() {
			this.rejectdetails = false;
			this.rejectdetailslist = '';
		},
		callParent() {
			this.showlist = true;
		},
		reset(){
			this.item={}
		},
		onSelect(item){

			this.item=item
			this.merchantnameFlt=item.value
		},
		getMerchantList() {
			this.listMerchantData1=[]
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'merchantList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
                        var merchantlistArray=[];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
					   result.data.forEach(function(item){
						   merchantlistArray[item.merchantid]=item.merchantname;

					   })
					   this.merchantList=merchantlistArray;
					   this.listMerchantData.forEach(ele=>{
						this.listMerchantData1.push({
							"value":ele.merchantid,
							"text":ele.merchantname
						})
					   })

					}

				}, error => {
					console.error(error)
				})
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getRecordLimit',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getOrderListForXls(3)
			}
		},
		encryptData(encData) {
			return this.encryptor.encrypt(encData);
		},
		decryptData(decData) {
			return this.encryptor.decrypt(decData);
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		calldateFunction: function() {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.fromDateFlt = dt;
		},

		time() {
			var self = this
			this.datenow = moment().format()
			setInterval(self.time, 1000)
		},
		getComponentPermission(innerdetail) {
			var component = 'orderlist';
			var innerpermArr = {};
			for (var i = 0; i < innerdetail.length; i++) {
				if (innerdetail[i].controllerurl == component) {
					innerpermArr = innerdetail[i].permission;
					break;
				}
			}

			if (JSON.stringify(innerpermArr) == 'null') {
				//alert("wrong");
			} else {
				for (var i = 0; i < innerpermArr.length; i++) {
					if (innerpermArr[i].id == 'cancel') {
						this.cancelOrderFlag = true;
					}
					if (innerpermArr[i].id == 'modify') {
						this.modifyOrderFlag = true;
					}
				}
			}

		},

		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		hideShowdateFlt() {
			if (this.searchstatus == "created") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = false;
				this.labelfromdate = '';
				this.labeltodate = '';
			}
			if (this.searchstatus == "allocated") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('editedjson.allocatedFromDate');
				this.labeltodate = this.$t('editedjson.allocatedToDate');
			}
			if (this.searchstatus == "picked") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('cancelPutawayPendingReport.pickedFromDate');
				this.labeltodate = this.$t('cancelPutawayPendingReport.pickedToDate');
			}
			if (this.searchstatus == "packed") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('editedjson.packedFromDate');
				this.labeltodate = this.$t('editedjson.packedToDate');
			}
			if (this.searchstatus == "dispatched") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('editedjson.dispatchedFromDate');
				this.labeltodate = this.$t('editedjson.dispatchedToDate');
			}
			if (this.searchstatus == "cancelled") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('cancelPutawayPendingReport.cancelledFromDate');
				this.labeltodate = this.$t('cancelPutawayPendingReport.cancelledToDate');
			}
			if (this.searchstatus == "rto") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('srReport.rTOFromDate');
				this.labeltodate = this.$t('srReport.rTOToDate');
			}
		},
		// getClientList() {
		// 	this.listClientData = '';
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');

		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	this.pageno = 0;

		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.clientid)
		// 			this.getSalesChannels();
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantList();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			this.getMerchantList();
		// 		}
		// 		this.listOrdersData = [];
		// 		this.pageno = this.totalPage = 0;
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getSalesChannels();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getCancelReasonList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({});
			axios({
					method: 'GET',
					'url': apiUrl.api_url + 'getCancelReasonList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listCancelReasonData = result.data.dataset;
				}, error => {
					console.error(error);
				});
		},
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.clientid == '') {
				this.WarehouseErr = this.$t('common.clientError');
				return false;
			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'orderSalesChannelList',
					'data': {
						clientid: this.clientid
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		getOrderList(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			if (this.ponoFlt == '' && (this.fromDateFlt == '' || this.fromDateFlt == null) && (this.toDateFlt == '' || this.toDateFlt == null)) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				this.totalRows = 0;
				return false;
			}
			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))
			if (this.ponoFlt == '' && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listOrdersData = [];
				return false;
			}

			if (this.fromdate != "") {
				this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			}
			if (this.todate != "") {
				this.todate = this.dateFormat(this.todate) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			this.isLoading = true;

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				pono: this.ponoFlt.trim(),
				shipmentid: this.shipidflt.trim(),
				fromDateFlt: this.dateFormat1(this.fromDateFlt),
				toDateFlt: this.dateFormat2(this.toDateFlt),
				fromDateFltStatus: this.dateFormat1(this.fromDateFltStatus),
				toDateFltStatus: this.dateFormat2(this.toDateFltStatus),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				searchchannel: this.searchchannel,
				searchstatus: this.searchstatus,
				csvData: csvCheck,
				userid: this.userid,
				sellername: this.merchantnameFlt,
				slastatus : this.searchSLA,
				rtvType:this.rtvType
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			this.filterData = this.input

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getOrderListData',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.csvFields = {
								'poid':this.$t('orders.orderId'),
								'merchant': this.$t('common.merchant'),
								'totalitem': this.$t('editedjson.totalItem'),
								'totalquantity':this.$t('common.totalQuantity'),
								'saleschannel': this.$t('common.salesChannel'),
								'status': this.$t('client.status'),
								'createdby': this.$t('common.createdBy'),
								'custmobile': this.$t('editedjson.Custmobile'),
								'gstamount': this.$t('editedjson.gstamount'),
								'modifieddatetime': this.$t('editedjson.modifiedDatetime'),
								'modifyby': this.$t('orders.modifyBy'),
								'customerfirstname': this.$t('editedjson.customerFirstName'),
								'customerlastname': this.$t('editedjson.customerLastName'),
								'shipmentcount': this.$t('common.shipmentId'),
								'subtotal': this.$t('purchaseOrder.subtotal'),
								'createddatetime': this.$t('stockTransfer.createdDate'),
								'remark2': this.$t('orders.orderCancelReason'),
								'acceptedqty': this.$t('orders.acceptedQty'),
								'eanids': this.$t('editedjson.eanIds'),
								'itemids':  this.$t('editedjson.itemids'),
								'itemid': this.$t('editedjson.itemid'),
								'productid': this.$t('common.productId'),
								'eancode': this.$t('common.eanCode'),
								'acceptedqty':  this.$t('orders.acceptedQty'),
								'itemstatus': this.$t('orders.itemStatus'),
								'shipids': this.$t('editedjson.Shipids'),
								'ordercode': this.$t('common.ordercode'),
								'status': this.$t('common.status'),
								'subtotal': this.$t('purchaseOrder.subtotal'),
								'reason': this.$t('editedjson.shipmentCancelReason'),
								'slastatus': this.$t('sla.slastatus'),
								'breachedby': this.$t('sla.breachedby'),
								'sladatetime':this.$t('sla.sladatetime')
							};
							var dateFilter = ['createddatetime', 'orderdate', 'modifieddatetime'];
							var skipFilter = ['orderdate', 'shipmentstatusct', 'shipmentstatus', 'warehouseid','sladiff','nearbrach'];
							if (!this.slaflag) {
								const keysToAdd = ['slastatus','breachedby','sladatetime'];
								keysToAdd.forEach(key => {
								  if (!skipFilter.includes(key)) {
									skipFilter.push(key);
								  }
								});
							}
							this.listOrdersDataCsv = result.data.data;
							csvHelper.data.jsonToCSV(this.$t('common.order'), this.listOrdersDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);
							// this.jsonToCSV('order', this.listOrdersDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						var resultArr = result.data.result
						// changes for rowspan
						for (var i = 0; i < resultArr.length; i++) {
							var shipidsArr = []
							var prodidsArr = []
							var itemidArr = []
							var prodAccptQty = []
							var Arrean = []
							var slaArr = []
							if (resultArr[i].itemids.length >= resultArr[i].shipids.length && resultArr[i].shipmentcount !='') {
								for (var j = 0; j < resultArr[i].itemids.length; j++) {
									if (j < resultArr[i].shipmentcount) {
										if (resultArr[i].shipids[j] != null) {
											shipidsArr[j] = resultArr[i].shipids[j]
										}
									} else {
										shipidsArr[j] = '-'
									}
								}
								resultArr[i].shipids = shipidsArr
							} else if (resultArr[i].itemids.length < resultArr[i].shipids.length) {
								for (var j = 0; j < resultArr[i].shipids.length; j++) {
									if (j < resultArr[i].itemids.length) {

										if (resultArr[i].itemids[j] != null) {
											prodidsArr[j] = resultArr[i].prodids[j]
											itemidArr[j] = resultArr[i].itemids[j]
											prodAccptQty[j] = resultArr[i].acceptedqty[j]
											Arrean[j] = resultArr[i].eanids[j]
											slaArr[j] = resultArr[i].sladatetime[j]
										}
									} else {
										prodidsArr[j] = '-'
										itemidArr[j] = '-'
										prodAccptQty[j] = '-'
										Arrean[j] = '-'
										slaArr[j] = '-'
									}
								}
								resultArr[i].prodids = prodidsArr
								resultArr[i].itemids = itemidArr
								resultArr[i].acceptedqty = prodAccptQty
								resultArr[i].eanids = Arrean
								resultArr[i].sladatetime = slaArr
							}
						}
						this.listOrdersData = result.data.result

						if (result.data.errorCode == -1) {
							this.resultCount = 0;
						} else {
							this.totalRows = result.data.totalRows;
							this.resultCount = result.data.totalRows;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows > 0) {
								if (this.totalRows <= this.pageLimit) {
									this.totalPage = 1;
								} else {
									this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
								}
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getOrderListForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			if (this.fromdate != "") {
				this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			}
			if (this.todate != "") {
				this.todate = this.dateFormat(this.todate) + " 23:59:59";
			}
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('srReport.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			if (localStorage.getItem("selectedClient") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}


			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				pono: this.ponoFlt.trim(),
				shipmentid: this.shipidflt.trim(),
				fromDateFlt: this.dateFormat1(this.fromDateFlt),
				toDateFlt: this.dateFormat2(this.toDateFlt),
				fromDateFltStatus: this.dateFormat1(this.fromDateFltStatus),
				toDateFltStatus: this.dateFormat2(this.toDateFltStatus),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				searchchannel: this.searchchannel,
				searchstatus: this.searchstatus,
				csvData: csvCheck,
				userid: this.userid,
				sellername: this.merchantnameFlt,
				slastatus : this.searchSLA,
				rtvType:this.rtvType
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getOrderListData',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls[this.$t('orders.orderId')]='poid',
							this.csvFieldsForXls[this.$t('common.merchant')]='merchant',
							this.csvFieldsForXls[this.$t('editedjson.totalItem')]='totalitem',
							this.csvFieldsForXls[this.$t('common.totalQuantity')]='totalquantity',
							this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel',
							this.csvFieldsForXls[this.$t('client.status')]='status',
							this.csvFieldsForXls[this.$t('common.createdBy')]='createdby',
							this.csvFieldsForXls[this.$t('editedjson.Custmobile')]='custmobile',
							this.csvFieldsForXls[this.$t('editedjson.gstamount')]='gstamount',
							this.csvFieldsForXls[this.$t('editedjson.modifiedDatetime')]='modifieddatetime',
							this.csvFieldsForXls[this.$t('orders.modifyBy')]='modifyby',
							this.csvFieldsForXls[this.$t('editedjson.customerFirstName')]='customerfirstname',
							this.csvFieldsForXls[this.$t('editedjson.customerLastName')]='customerlastname',
							this.csvFieldsForXls[this.$t('common.shipmentId')]='shipmentcount',
							this.csvFieldsForXls[this.$t('purchaseOrder.subtotal')]='subtotal',
							this.csvFieldsForXls[this.$t('stockTransfer.createdDate')]='createddatetime',
							this.csvFieldsForXls[this.$t('orders.orderCancelReason')]='remark2',
							this.csvFieldsForXls[this.$t('orders.acceptedQty')]='acceptedqty',
							this.csvFieldsForXls[this.$t('editedjson.eanIds')]='eanids',
							this.csvFieldsForXls[this.$t('editedjson.itemids')]='itemids',
							this.csvFieldsForXls[this.$t('editedjson.itemid')]='itemid',
							this.csvFieldsForXls[this.$t('common.productId')]='productid',
							this.csvFieldsForXls[this.$t('common.eanCode')]='eancode',
							this.csvFieldsForXls[this.$t('orders.acceptedQty')]='acceptedqty',
							this.csvFieldsForXls[this.$t('orders.itemStatus')]='itemstatus',
							this.csvFieldsForXls[this.$t('editedjson.Shipids')]='shipids',
							this.csvFieldsForXls[this.$t('common.ordercode')]='ordercode',
							this.csvFieldsForXls[this.$t('common.status')]='status',
							this.csvFieldsForXls[this.$t('purchaseOrder.subtotal')]='subtotal',
							this.csvFieldsForXls[this.$t('editedjson.shipmentCancelReason')]='reason',
							this.csvFieldsForXls[this.$t('sla.slastatus')]='slastatus',
							this.csvFieldsForXls[this.$t('sla.breachedby')]='breachedby',
							this.csvFieldsForXls[this.$t('sla.sladatetime')]='sladatetime',
							this.listReportDataforxls = result.data.data;
							const keysToRemove = [this.$t('sla.slastatus'), this.$t('sla.breachedby'),this.$t('sla.sladatetime')];
							if (!this.slaflag) {
							  keysToRemove.forEach(key => {
								if (this.csvFieldsForXls.hasOwnProperty(key)) {
								  delete this.csvFieldsForXls[key];
								}
							  });
							}
							this.listReportDataforxls.forEach(function(entry) {
								if (entry.modifieddatetime != '' && entry.modifieddatetime != null) {
									entry.modifieddatetime = moment(entry.modifieddatetime).format('YYYY-MM-DD HH:mm:ss');

								}
								if (entry.createddatetime != '' && entry.createddatetime != null) {
									entry.createddatetime = moment(entry.createddatetime).format('YYYY-MM-DD HH:mm:ss');

								}

							});
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}


				}, error => {
					console.error(error);
				})
		},
		cancelOrder() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.orderCancelShow = false;
			this.comfirmModal = false;
			this.modifyOrdere = false;
			if (localStorage.getItem("selectedClient") == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			this.isLoading = true;
			if (this.OthersReason != '' || this.OthersReason != null) {
				this.cancelReason = this.OthersReason
			}
			if (this.OthersReason == '' || this.OthersReason == null) {
				this.cancelReason = this.cancelreasonid
			}
			if (this.shipmentid == null || this.shipmentid == '' || this.shipmentid==='-') {
				this.cancelorderForwithoutshipmentid();
			} else {
				this.input = {
					clientid: localStorage.getItem("selectedClient"),
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					orderid: this.cancelOrderId,
					userid: this.loginuserid,
					cancelreason: this.cancelReason,
					shipmentid: this.shipmentid,
					useremail: this.loginuseremail
				}
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'cancelOrderShipment',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						if (result.data.data.ErrorCode == 0) {
							this.$alertify.success(this.$t('orders.orderCancelled'));
							this.OthersReason = '';
							this.cancelreasonid = '';
							this.shipmentid = '';
							this.onPageChange(this.currentPage)
						} else {
							this.$alertify.error(this.$t('orders.failed'));
							this.OthersReason = '';
							this.cancelreasonid = '';
						}
						this.isLoading = false;

					}, error => {
						console.error(error);
					});
			}

		},
		cancelorderForwithoutshipmentid() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.orderCancelShow = false;
			this.comfirmModal = false;
			this.modifyOrdere = false;
			if (this.client == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			this.isLoading = true;

			this.input = {
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				orderid: this.cancelOrderId,
				userid: this.loginuserid,
				cancelReason: this.cancelReason,

			}
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'cancelOrder',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(this.$t('orders.orderCancelled'));
						this.onPageChange(this.currentPage)
					} else {
						this.$alertify.error(this.$t('orders.failed'));
					}
					this.isLoading = false;

				}, error => {
					console.error(error);
				});
		},
		// called onchange of client id
		getNewClientData() {
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = false;
			this.listOrdersData = [];
			this.ponoFlt = '';
			this.shipidflt = '';
			this.fromDateFlt = "";
			this.toDateFlt = "";
			document.getElementById('ponoFlt').value = "";
			document.getElementById('shipidflt').value = "";

			if (this.client == "") {
				return false;
			} else {
				this.getOrderList();
			}
		},
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.pageLimit;
		// 	this.getOrderList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getOrderList()
		},
		getOrderSerach() {
			this.currentPage = 1;
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.totalRows = 0;
			this.searchFlag = true;
			this.getOrderList(2);
		},
		resetOrderSerach() {
			this.searchSLA=''
			this.item={};
			this.merchantnameFlt = '';
			this.show = false;
			this.download = true;
			this.ClientErr = '';
			this.$validator.reset();
			this.ponoFlt = '';
			this.shipidflt = '';
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.searchstatus = '';
			document.getElementById("searchstatus").value = '';
			this.searchchannel = '';
			this.listOrdersData = [];
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = false;
			this.statusFlag = false;
			this.fromDateFltStatus = '';
			this.toDateFltStatus = '';
			this.rtvType='';
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
			// this.getOrderList();
		},
		formatPrice(value) {
			value = value ? value : 0;
			return Number.parseFloat(value).toFixed(2);
		},

		//shipmentDetails
		shipmentDetails(poid, shipmentcount) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			var shipmentcount = shipmentcount;
			if (shipmentcount) {
				this.shipmentdetailslist = '';
				this.orderidshipment = poid;
				this.input = {
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					clientid: localStorage.getItem("selectedClient"),
					orderno: this.orderidshipment
				};
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'shipmentsDetailsOfOrder',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						if (result.data.errorCode == 0) {
							this.shipmentdetailslist = result.data.data;
							this.shipmentdetails = true;
						} else {
							this.shipmentdetailslist = {};
							this.shipmentdetails = true;
						}
					}, error => {
						console.error(error)
					})
			}
		},
		//shipmentdetails Close
		shipmentDetailsClose() {
			this.shipmentdetails = false;
			this.orderidshipment = '';
			this.shipmentdetailslist = '';
		},
		//validate all form fields on onsubmit()
		onSubmit: function() {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},

		viewOrderData(data) {
			this.pono = data.poid;
			window.localStorage.setItem('pono', this.pono);
			window.localStorage.setItem('client', this.client);
			window.location.href = apiUrl.baseUrl + 'orderdetails';
		},

		orderProdDetails(poid, shipmentcount) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			var shipmentcount = shipmentcount;
			if (shipmentcount) {
				this.shipmentdetailslist = '';
				this.orderidshipment = poid;
				this.input = {
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					clientid: localStorage.getItem("selectedClient"),
					orderno: this.orderidshipment
				};
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'shipmentsDetailsOfOrder',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr,
						}
					})
					.then(result => {
						if (result.data.errorCode == 0) {
							this.shipmentdetailslist = result.data.data;
							this.shipmentdetails = true;
						} else {
							this.shipmentdetailslist = {};
							this.shipmentdetails = true;
						}
					}, error => {
						console.error(error)
					})
			}
		},

		geModifyOrder(data) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.input = {
				warehouseid: localStorage.getItem("selectedWarehouse"),
				clientid: localStorage.getItem("selectedClient"),
				pono: data.poid,
			};
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getOrderProductDetails',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					var resultArr = []
					if (result.data.errorCode == 0) {
						resultArr = result.data.data;
						this.orderProdList = []
						this.modifyOrderID = data.poid
						for (var i = 0; i < resultArr.resultDT.length; i++) {
							this.orderProdList.push({
								"orderid": resultArr.resultDT[i].poid,
								"eancode": resultArr.resultDT[i].eancode,
								"productid": resultArr.resultDT[i].productid,
								"itemid": resultArr.resultDT[i].itemid,
								"productname": resultArr.resultDT[i].productname,
								"orderqty": resultArr.resultDT[i].acceptedqty,
								"modifyqty": resultArr.resultDT[i].acceptedqty,
								"shipmentid": resultArr.resultDT[i].shipmentid,
								"status": resultArr.resultDT[i].status,

								"isqtycheck": true
							})
						}
						this.modifyOrdere = true
					} else {
						this.shipmentdetailslist = {};
						this.shipmentdetails = true;
					}
				}, error => {
					console.error(error)
				})
		},

		confirmation() {
			if (this.isWholeOrderCancel) {
				this.cancelOrder();
			} else {
				if (this.modifyOrderInput.productDetails[0].shipmentid == undefined) {
					this.modifyOrder(this.modifyOrderInput);

				} else {
					this.modifyBYShipemntIDOrder(this.modifyOrderInput);

				}
			}

		},
		modifyOrderValidate(data) {
			this.modifyOrderInput = {}
			this.cancelOrderId = ''
			var prodArr = []
			var totalProduct = this.orderProdList.length
			var totalCancelProduct = 0
			this.isWholeOrderCancel = false
			for (var i = 0; i < this.orderProdList.length; i++) {
				if (parseInt(this.orderProdList[i].modifyqty) <= parseInt(this.orderProdList[i].orderqty) && this.orderProdList[i].isqtycheck == true) {
					if (this.orderProdList[i].shipmentid != null && this.orderProdList[i].shipmentid != '') {
						prodArr.push({
							"productid": this.orderProdList[i].productid,
							"itemid": this.orderProdList[i].itemid,
							"quantity": this.orderProdList[i].modifyqty,
							"shipmentid": this.orderProdList[i].shipmentid,
						});
					} else {
						prodArr.push({
							"productid": this.orderProdList[i].productid,
							"itemid": this.orderProdList[i].itemid,
							"quantity": this.orderProdList[i].modifyqty
						});
					}

					if (parseInt(this.orderProdList[i].modifyqty) == 0) {
						totalCancelProduct++
					}
				} else {
					this.orderProdList[i].qtyErr = this.$t('orders.modifyQuantityPlaceHolder')
					// this.isqtycheck = true
					return false;
				}
			}

			if (totalCancelProduct == totalProduct) {
				this.isWholeOrderCancel = true
			}
			this.modifyOrderInput = {
				"warehouseid": localStorage.getItem("selectedWarehouse"),
				"clientid": localStorage.getItem("selectedClient"),
				"orderid": this.modifyOrderID,
				"userid": this.loginuserid,
				"productDetails": prodArr
			}

			if (this.isWholeOrderCancel) {
				this.modalHeader = this.$t('orders.cancelOrderPopup');
				this.modalTitle =  this.$t('orders.cancelOrderBtn');
				this.cancelOrderId = this.modifyOrderID
				//this.cancelOrder();
			} else {
				this.modalTitle = this.$t('orders.modifyOrderBtn');
				this.modalHeader = this.$t('orders.modifyOrderPopup');
				//this.modifyOrder(input);
			}
			this.comfirmModal = true;
		},

		checkmodifyqty(data, index) {
			// this.isqtycheck = false

			var reg = new RegExp('^[0-9]+\d*$')
			var result = reg.test(data.modifyqty)
			if (data.modifyqty == "") {
				this.orderProdList[index].qtyErr = this.$t('orders.enterModifyQty')
				this.orderProdList[index].isqtycheck = false
				return false;
				// this.isqtycheck = true
			} else {
				this.orderProdList[index].qtyErr = ''
				this.orderProdList[index].isqtycheck = true
			}

			if (result == false) {
				// data.qnty = data.qnty.replace(new RegExp(/[^\d]/, 'ig'), "");
				data.modifyqty = ''
				return false;
			}


			if (Number(data.orderqty) < Number(data.modifyqty)) {
				this.orderProdList[index].qtyErr = this.$t('orders.modifyQuantityPlaceHolder')
				this.orderProdList[index].isqtycheck = false
				return false;
				// this.isqtycheck = true
			} else {
				this.orderProdList[index].isqtycheck = true
				this.orderProdList[index].qtyErr = ''
				// this.isqtycheck = false
			}
		},


		modifyOrder(input) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.orderCancelShow = false;
			this.comfirmModal = false;
			this.modifyOrdere = false;
			if (this.client == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			this.input = input
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'modifyOrder',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(this.$t('orders.orderModified'));
						this.onPageChange(this.currentPage)
					} else {
						if(result.data.data.data[0].msg){
							this.$alertify.error(result.data.data.data[0].msg);
						}else {
							this.$alertify.error(this.$t('orders.failed'));
						}
					}
					this.isLoading = false;

				}, error => {
					console.error(error);
				});
		},
		getUnPackBox(data,shipmentid){
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = {
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				pono: data.poid,
				shipmentid : shipmentid,
			};
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getUnPackBox',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
			.then(result => {
				if (result.data.errorCode == 0) {
					console.log(result.data.data);
					var boxids = result.data.data.split(',');
					for (var i = 0; i < boxids.length; i++) {
						this.unPackBox(boxids[i])
					}
				  //this.unPackBox(result.data.data)
				} else if (result.data.errorCode == -1) {
					this.$alertify.error(result.data.msg)
				}
				this.isLoading = false;

			})
		},
		unPackBox(boxid) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = {
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				boxid: boxid,
			};
			console.log(this.input);
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'unpackingboxid',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data[0].ErrorCode == 0) {
						this.$alertify.success(result.data.data[0].msg)
						this.onPageChange(this.currentPage)
					} else if (result.data.data[0].ErrorCode == -1) {
						this.$alertify.error(result.data.data[0].msg)
					}

					this.isLoading = false;

				})
		},
		modifyBYShipemntIDOrder(input) {

			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.orderCancelShow = false;
			this.comfirmModal = false;
			this.modifyOrdere = false;
			if (this.client == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			this.input = input
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'modifyShipmentwiseOrder',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(this.$t('orders.orderModified'));
						this.onPageChange(this.currentPage)
					} else {
						this.$alertify.error(this.$t('orders.failed'));
					}
					this.isLoading = false;

				}, error => {
					console.error(error);
				});
		}
	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/reports/orderlist/orderlist.component.js